import { CONTACT } from "@/constants/contact";

// Shared customer-facing wording — one place so the hero, estimate card, booking popup,
// About, FAQ and thank-you page always say the same thing.
export const COPY = {
  credit: "$50 estimate visit, fully credited to your job if you hire me.",
  rates: "$85/hr · 2-hour minimum · $50 trip charge per work day.",
  confirm: "I'll confirm your visit by email, usually within one business day, Mon–Fri 9–5.",
  guarantee: "If my workmanship fails, I come back and fix it free, for as long as you own the home.",
  trust: "Licensed, bonded & insured",
  textPhoto: `Text a photo: ${CONTACT.phoneDisplay}`,
};

export const LICENSE_URL = "https://secure.lni.wa.gov/verify/Detail.aspx?UBI=606272681&LIC=SOLIDHS742NQ&SAW=";
